import UserList from "components/Picker/UserPicker/UserList";
import React, { useContext, useEffect } from "react";
import { FilterContext } from "../FilterContext";
import { areArrayValuesEqual } from "../FilterGroups/instructionUtils";
import { getSortedOwnerLabels, initialOwnersFilter } from "./FilterTypes/OwnerFilterType";
import MultiPickerFilterPopup from "./MultiPickerFilterPopup";

interface Props {
  title?: string
}

/*
 * This is a variation on the owner filter that allows only a single owner to be selected.
 * It is using the same filter as the multi owner filter, so the two cannot be used at the same time.
 */
const SingleOwnerFilter = (props: Props) => {
  const title = props.title || RESX.GeneralLabels.Owner;

  const { register, getValue, setInitialValue, setValue } = useContext(FilterContext);
  register("owners", {
    getTitle: () => title,
    renderSelection: (filter) => <>{getSortedOwnerLabels(filter).join(", ")}</>,
    hasValue: (filter) => filter.selectedOwners.length > 0,
    reset: () => initialOwnersFilter,
    areEqual: (a, b) => areArrayValuesEqual(a.selectedOwners.map(s => s.userId), b.selectedOwners.map(s => s.userId))
  });
  useEffect(() => {
    setInitialValue("owners", initialOwnersFilter);
  }, []);

  const [selectedOwners, setSelectedOwners] = React.useState<server.dto.UserSmall[]>(initialOwnersFilter.selectedOwners);
  const [popupOpen, setPopupOpen] = React.useState<boolean>(false);

  const onPopupClose = () => {
    onApply();
  };

  const onPopupOpen = () => {
    setSelectedOwners(getValue("owners").selectedOwners);
    setPopupOpen(true);
  };

  const onSelect = (owner: server.dto.UserSmall) => {
    setSelectedOwners([owner]);
    setValue("owners", { selectedOwners: [owner] });
    setPopupOpen(false);
  }

  const onApply = (e?) => {
    e?.preventDefault();
    setValue("owners", { selectedOwners });
    setPopupOpen(false);
  };

  return <div>
    <MultiPickerFilterPopup
      title={title}
      minHeight={350}
      width={400}
      open={popupOpen}
      onClose={onPopupClose}
      onOpen={onPopupOpen}
      onApply={onApply}
    >
      <UserList
        onUserSelected={onSelect}
        excludedUsers={selectedOwners.map(u => u.userId)}
        canChooseDeactivated
      />
    </MultiPickerFilterPopup>
  </div>;
};

export default SingleOwnerFilter;
